import Vue from "vue";
export default {
  getLogs({ commit, state }) {
    const params = {
      per_page: state.perPageForLogs,
      page: state.currentPageForLogs,
      ...(state.searchQuery && {
        search_query: state.searchQuery,
      }),
      ...(state.filterDate && {
        date: state.filterDate,
      }),
      ...(state.filterStatus && {
        status: state.filterStatus,
      }),
    };
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      Vue.$http
        .get("/attendance/me/mobile-clocks/", {
          params,
        })
        .then(response => {
          commit("tableLoading", false);
          const { results, total } = response.data;
          commit("logs", results);
          commit("totalLogs", total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  handleSizeChangeForLogs({ commit, dispatch }, perPage) {
    commit("perPageForLogs", perPage);
    commit("currentPageForLogs", 1);
    dispatch("getLogs");
  },
  handleCurrentChangeForLogs({ commit, dispatch }, page) {
    commit("currentPageForLogs", page);
    dispatch("getLogs");
  },
};
